// 签到
<template>
  <div class="box" v-if="show">
    <div class="top">
      <div class="top_l">
        <div class="top_l_t">签到领劵</div>
        <div class="top_l_b">
          已领取 <span>{{ received }}</span> <b>/{{ total }}</b> 张
        </div>
      </div>
      <el-button type="primary" class="top_r" @click="signInModeOnshow">
        <div>签到</div>

        <img class="icon" src="@/assets/image/home/sign-in/icon_0.webp" alt="" srcset=""
      /></el-button>
    </div>
    <div class="content">
      <signInItem :data="item" v-for="item in getGroupForToday" :key="item.checkInId" />
    </div>

    <signInMode ref="signInMode" @sing="signInModeCallback" />
    <sigInSuccess ref="sigInSuccess" />
    <signInSelect ref="signInSelect" @confirm="confirm" @cancel="cancel" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import signInItem from "./sign-in-item.vue";
import signInMode from "@/components/signIn/signInMode.vue";
import userinfo from "@/mixins/userinfo.js";
import sigInSuccess from "@/components/signIn/sigInSuccess.vue";
import signInSelect from "@/components/signIn/signInSelect.vue";
export default {
  name: "banner-carousel",
  components: {
    signInItem,
    signInMode,
    sigInSuccess,
    signInSelect,
  },
  mixins: [userinfo],
  data() {
    return {};
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapState("signInList", ["list"]),
    ...mapGetters("signInList", ["checkInTypesList"]),
    total() {
      return this.checkInTypesList.length;
    },

    received() {
      return this.checkInTypesList.filter((item) => item.type === "Checked").length;
    },
    show() {
      if (!this.user.showCheckIn) {
        return false;
      }
      if (this.getGroupForToday.length === 0) {
        return false;
      }
      return true;
    },
    getGroupForToday() {
      const data = this.checkInTypesList;
      // 获取今天的日期，格式为 'yyyy-mm-dd'
      const today = new Date();
      const todayStr = today.toISOString().split("T")[0]; // 格式化为 yyyy-mm-dd

      // 分割数据为每7条一组
      const groups = [];
      for (let i = 0; i < data.length; i += 7) {
        groups.push(data.slice(i, i + 7));
      }

      // 判断每个项的 timeWindow 是否与今天的日期匹配
      for (let group of groups) {
        for (let item of group) {
          const itemDate = new Date(item.timeWindow * 1000); // 假设 timeWindow 是以秒为单位的时间戳
          const itemDateStr = itemDate.toISOString().split("T")[0]; // 转换为 'yyyy-mm-dd'

          if (itemDateStr === todayStr) {
            return group; // 如果找到匹配的日期，返回这一组
          }
        }
      }

      return []; // 如果没有找到今天的那一组，返回 null
    },
  },
  methods: {
    ...mapActions("signInList", ["getList"]),
    // 签到
    signInModeOnshow() {
      if (!this.user.creator) {
        this.$confirm("仅限法人账号使用", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
      this.$refs.signInMode.onshow();
    },
    // 签到成功
    sigInSuccessOnshow() {
      this.$refs.sigInSuccess.onshow();
    },
    // 选择账号
    signInSelectOnshow() {
      this.$refs.signInSelect.onshow();
    },
    // 签到回调
    signInModeCallback() {
      this.signInSelectOnshow();
      this.getList();
    },
    // 选择账号确定
    async confirm(uuid) {
      const success = await this.putCheckIn(uuid);
      if (!success) return;
      this.$refs.signInSelect.onclose();
      this.sigInSuccessOnshow();
    },
    // 选择账号取消
    cancel() {
      this.signInModeOnshow();
    },
    async putCheckIn(uuid) {
      if (!uuid) {
        this.$message({
          type: "error",
          message: "请选择账号",
        });
        return;
      }
      const { status, info } = await this.$api.putCheckIn({
        accountUuid: uuid,
      });
      if (status === 200) {
        return true;
      } else {
        this.$message({
          type: "error",
          message: info,
        });
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 140px;
  border-radius: $border-radius;
  background: #ffffff;

  overflow: hidden;
  .top {
    display: flex;
    width: 320px;
    height: 72px;
    justify-content: space-between;
    padding: 0 16px;
    align-items: center;
    &_l {
      &_t {
        line-height: 23px;

        font-size: 16px;
        font-weight: 500;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
      }
      &_b {
        color: #999999;
        font-family: "Noto Sans SC";
        font-size: 12px;
        font-weight: 500;
        span {
          color: #0062ff;
        }
        b {
          color: #666666;
        }
      }
    }
    &_r {
      ::v-deep span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      width: 72px;
      height: 28px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 1;

      .icon {
        width: 16px;
        height: 16px;
        margin-left: 4px;
      }
    }
  }
  .content {
    padding: 0 16px;
    display: flex;
    gap: 6px;
  }
}
</style>
